define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {
            event: 'click', // the event to open the modal on
            contentElement: null, // selector for the  Modal component
            replaceHtmlAfterClose: true, // if true will restore the html to the initial state
            activeCssClass: 'is-active',
            openOnLoad: false,
            closeOnOverlay: true,
            cookieName: null,
            cookieExpiresIn: null
        },

        init: function () {
            var self = this;

            self.contentElement = document.querySelector(self.options.contentElement);

            self.contentElementHtml = self.contentElement.innerHTML;

            this.initEvents();
        },

        initEvents: function () {
            var self = this;

            // opening the modal
            if (!self.options.openOnLoad) {
                self.el.addEventListener(self.options.event, function (e) {
                    e.preventDefault();
                    self.openDialog();
                });   
            }

            // closing window by clicking close link
            var closeLink = self.contentElement.querySelector('.js-close');
            if (closeLink != null) {
                closeLink.addEventListener('click', function (e) {
                    e.preventDefault();
                    self.closeDialog();
                });
            }

            // closing window by clicking accept link
            var acceptAndCloseLink = self.contentElement.querySelector('.js-acceptAndClose');
            if (acceptAndCloseLink != null) {
                acceptAndCloseLink.addEventListener('click', function (e) {
                    e.preventDefault();
                    self.setCookie();
                    self.closeDialog();
                });
            }

            // closing window by clicking overlay
            if (self.options.closeOnOverlay) {
                self.contentElement.addEventListener('click', function (e) {
                    if (!e.target.matches('.Modal')) {
                        return;
                    }

                    e.preventDefault();
                    self.closeDialog();
                });
            }

            if (self.options.openOnLoad) {
                self.openDialog();
            }
        },

        openDialog: function () {
            var self = this;

            // move modal element to body to avoid z-index issues.
            if (self.contentElement.parentElement != document.body) {
                self.contentElement = self.contentElement.parentElement.removeChild(self.contentElement);
                document.body.appendChild(self.contentElement);
            }

            self.contentElement.classList.add(self.options.activeCssClass);

            var event = new CustomEvent('modal-open');
            self.el.dispatchEvent(event);
            self.contentElement.dispatchEvent(event);
            self.contentElement.focus();

            function closeOnEsc(e) {
                if (e.key === "Escape") {
                    document.removeEventListener('keydown', closeOnEsc);
                    self.closeDialog();
                }
            }
            document.addEventListener('keydown', closeOnEsc);
        },

        closeDialog: function () {
            var self = this;

            self.contentElement.classList.remove(self.options.activeCssClass);

            if (self.options.replaceHtmlAfterClose) {
                self.contentElement.innerHTML = self.contentElementHtml;
                Moduler.loadModules(self.contentElement);
            }

            var event = new CustomEvent('modal-close');
            self.el.dispatchEvent(event);
            self.contentElement.dispatchEvent(event);
        },

        setCookie: function () {
            var date = new Date(),
                self = this;

            var expires = '';
            if (self.options.cookieExpiresIn > 0) {
                date.setTime(date.getTime() + (self.options.cookieExpiresIn * 60 * 1000));
                expires = ';expires=' + date.toUTCString();
            }

            document.cookie = self.options.cookieName + '=seen' + expires + ';SameSite=Strict;path=/';
        },
    });
});